// FlightInfo.js
import {
    defineComponent,
    computed,
    toRefs,
    ref,
    inject,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
    name: "FlightInfo",
    props: {
        flight: {
            type: Object,
            required: true,
        },
    },
    emits: [],
    setup(props, { emit }) {
        const { flight } = toRefs(props);
        return {
            flight,
        };

        return { };
    },
    template: html`
        <div class="card">
            <div class="card__title">
                <div class="day">第{{flight.day}}天</div>
                <div class="airlineImg">
                    <img :src="getAirlineImg(flight.airline)" alt="" />
                </div>
                <div class="airplane">
                    {{flight.airlineName}} {{flight.flightNumber}}
                </div>
            </div>
            <div class="card__content">
                <div class="flight">
                    <div class="airport">
                        {{flight.departureName}}
                        <span>{{flight.departure}}</span>
                    </div>
                    <div class="date">
                        {{getWeekDay(flight.departureDate)}}
                        <span class="time">{{flight.departureTime}}</span>
                    </div>
                </div>
                <div class="line"></div>
                <div class="flight">
                    <div class="airport airport_dest">
                        {{flight.arrivalName}}
                        <span>{{flight.arrival}}</span>
                    </div>
                    <div class="date">
                        {{getWeekDay(flight.arrivalDate)}}
                        <span class="time">{{flight.arrivalTime}}</span>
                    </div>
                </div>
            </div>
        </div>
    `,
    methods: {
        getWeekDay(date) {
            const weekDays = ["日", "一", "二", "三", "四", "五", "六"];
            const day = new Date(date).getDay();
            return date + "（" + weekDays[day] + "）";
        },
        getAirlineImg(airline) {
            return `https://fit.bwt.com.tw/Ticket/Content/images/airline/${airline}.gif`;
        }
    },
});
